import {MEASURE_TEMPLATE_VALUE} from '@/constants';
import {NamedStatisticContent} from '@/resources/index';

const MB_SEC_FIELD_NAME = 'mb_sec';

export const MB_SEC_ADDITIONAL_INFO = {
  fieldName: MB_SEC_FIELD_NAME,
  parameterName: 'param1',
  text: `За это время %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} можно было посмотреть фильм «Ирония судьбы, или С легким паром!».`,
  plurals: ['раз', 'раза', 'раз'],
  durationInMin: 192,
};

export const statisticContent: NamedStatisticContent[] = [
  {
    name: 'clothes_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы потратили на одежду и обувь в 2024 году.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы потратили на одежду и обувь.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'clothes_fav_brand',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ваш любимый магазин для покупки одежды и обуви в 2024 году.',
        plurals: [],
      },
      description: {
        text: 'Чаще всего совершали покупки в %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'food_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы потратили в категории «Рестораны и фастфуд» в 2024 году.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы потратили в ресторанах и фастфуде.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'food_fav_brand',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ваше любимое заведение из категории «Рестораны и фастфуд» в 2024 году.',
        plurals: [],
      },
      description: {
        text: 'Чаще всего выбирали %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'pets_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы потратили в этом году на радости для питомцев.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы потратили на радости для питомцев.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'pets_fav_item',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Это ваш фаворит среди товаров для животных.',
        plurals: [],
      },
      description: {
        text: 'Ваш фаворит в чеках — %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'beauty_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы инвестировали в салоны красоты за год.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы инвестировали в салоны красоты за год.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'beauty_fav_brand',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Это ваше самое посещаемое место для бьюти‑преображения.',
        plurals: [],
      },
      description: {
        text: 'Ваше самое частое место преображения — %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'avia_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы потратили в этом году на авиабилеты.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы потратили в этом году на авиабилеты.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'transport_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Это ваши транспортные расходы в 2024 году.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} - ваши транспортные расходы в этом году.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'transport_fav_kind',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Это ваш самый популярный вид транспорта в 2024 году.',
        plurals: [],
      },
      description: {
        text: 'Самый популярный вид транспорта - %yellowColor%$param1%yellowColor% — как сани для Деда Мороза.',
        plurals: [],
      },
    },
  },
  {
    name: 'grocery_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы оставили в супермаркетах за год.',
        plurals: [],
      },
      description: {
        text: `Вы потратили на покупки в супермаркетах %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'grocery_fav_brand',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ваш любимый супермаркет в этом году.',
        plurals: [],
      },
      description: {
        text: '%yellowColor%$param1%yellowColor% — ваше любимое место для покупок.',
        plurals: [],
      },
    },
  },
  {
    name: 'grocery_fav_item',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Главный товар вашей продуктовой корзины в этом году.',
        plurals: [],
      },
      description: {
        text: 'А %yellowColor%$param1%yellowColor% - главный товар вашей продуктовой корзины.',
        plurals: [],
      },
    },
  },
  {
    name: 'mp_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Это сумма ваших трат на маркетплейсах в 2024 году.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} - сумма ваших трат на маркетплейсах в этом году.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'mp_fav_brand',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Этот маркетплейс чаще других отправлял вам посылки в 2024 году.',
        plurals: [],
      },
      description: {
        text: '%yellowColor%$param1%yellowColor% чаще других отправлял вам посылки.',
        plurals: [],
      },
    },
  },
  {
    name: 'home_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы потратили на обустройство дома в этом году.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы потратили на обустройство дома в этом году.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'zodiac_sign',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Звезды подсказывают, что у вас прекрасная финансовая совместимость с этим знаком зодиака.',
        plurals: [],
      },
      description: {
        text: 'Звезды подсказывают, что у вас прекрасная финансовая совместимость с %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'min_spend_tran_amt_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько стоила ваша самая скромная покупка в этом году.',
        plurals: [],
      },
      description: {
        text: `Ваша самая скромная покупка стоила %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'min_spend_tran_brand',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'В этом месте вы совершили самую скромную покупку в 2024 году.',
        plurals: [],
      },
      description: {
        text: 'Вы совершили ее в %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'min_spend_tran_date',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Дата вашей самой мелкой покупки в этом году.',
        plurals: [],
      },
      description: {
        text: 'Этот чек появился %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'max_cnt_tran_dt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'В этот день вы совершили больше всего покупок по карте в 2024 году.',
        plurals: [],
      },
      description: {
        text: 'Вы совершили их %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'max_cnt_tran_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: `$param1 ${MEASURE_TEMPLATE_VALUE}`,
        text: 'Ваше самое большое количество покупок в один день.',
        plurals: ['покупка', 'покупки', 'покупок'],
      },
      description: {
        text: `Суммарно у вас было %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['покупка', 'покупки', 'покупок'],
      },
    },
  },
  {
    name: 'frac_onl_tran',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1%',
        text: 'Такой процент покупок вы сделали онлайн в этом году.',
        plurals: [],
      },
      description: {
        text: '%yellowColor%$param1%%yellowColor% от общего числа покупок.',
        plurals: [],
      },
    },
  },
  {
    name: 'charity_spend_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы перевели в благотворительные фонды.',
        plurals: [],
      },
      description: {
        text: `Вы перевели %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} в благотворительные фонды.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'data_gb',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько гигабайтов вы использовали в 2024 году.',
        plurals: [],
      },
      description: {
        text: `Вы использовали %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} в 2024 году.`,
        plurals: ['гигабайт', 'гигабайта', 'гигабайт'],
      },
    },
  },
  {
    name: 'cnt_call',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько звонков вы сделали с использованием Т‑Мобайла в 2024 году.',
        plurals: [],
      },
      description: {
        text: `А еще вы сделали %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} с использованием Т‑Мобайла.`,
        plurals: ['звонок', 'звонка', 'звонков'],
      },
    },
  },
  {
    name: 'max_call_len_sec',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько минут длился ваш самый долгий разговор с использованием Т‑Мобайла в 2024 году.',
        plurals: [],
      },
      description: {
        text: `Ваш самый долгий разговор длился %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['минуту', 'минуты', 'минут'],
      },
    },
  },
  {
    name: 'seconds_in_air',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько часов вы провели в перелетах, купленных через наш сервис «Путешествия» в Городе в 2024 году.',
        plurals: [],
      },
      description: {
        text: `Вы провели %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} в перелетах, купленных через наше приложение.`,
        plurals: ['час', 'часа', 'часов'],
      },
    },
  },
  {
    name: 'afisha_event_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько мероприятий вы посетили, купив билеты через наш сервис «Афиша» в Городе в 2024 году.',
        plurals: [],
      },
      description: {
        text: `Вы посетили %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}, купив билеты через наш сервис «Афиша» в Городе в 2024 году.`,
        plurals: ['мероприятие', 'мероприятия', 'мероприятий'],
      },
    },
  },
  {
    name: 'fuel_order_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько раз вы заправились через сервис «Топливо» в Городе в 2024 году.',
        plurals: [],
      },
      description: {
        text: `Вы заправились %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} раз через сервис «Топливо» в Городе в 2024 году.`,
        plurals: ['раз', 'раза', 'раз'],
      },
    },
  },
  {
    name: 'wordle_correct_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: `$param1 ${MEASURE_TEMPLATE_VALUE}`,
        text: 'Столько слов вы угадали в игре «5 букв» в этом году.',
        plurals: ['слово', 'слова', 'слов'],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} - вы угадали в игре «5 букв».`,
        plurals: ['слово', 'слова', 'слов'],
      },
    },
  },
  {
    name: 'top_1_spend_tran_amt_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'На такую сумму вы сделали самую большую покупку года.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} - на такую сумму вы сделали самую большую покупку года.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'top_2_spend_tran_amt_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'На такую сумму вы сделали самую большую покупку года.',
        plurals: [],
      },
      description: {
        text: `%br%%br%Следующая по величине стоила вам %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'top_3_spend_tran_amt_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'На такую сумму вы сделали самую большую покупку года.',
        plurals: [],
      },
      description: {
        text: `%br%%br%На следующую вы потратили %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'top_1_spend_tran_brand',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Здесь вы совершили самую большую покупку в этом году.',
        plurals: [],
      },
      description: {
        text: 'Вы совершили ее в %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'top_2_spend_tran_brand',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Здесь вы совершили самую большую покупку в этом году.',
        plurals: [],
      },
      description: {
        text: 'Вы выбрали для этой покупки %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'top_3_spend_tran_brand',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Здесь вы совершили самую большую покупку в этом году.',
        plurals: [],
      },
      description: {
        text: 'Вы сделали покупку в %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'frac_night_tran',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1%',
        text: 'Такая часть ваших покупок случилась в ночное время.',
        plurals: [],
      },
      description: {
        text: '%yellowColor%$param1%%yellowColor% ваших покупок случилось в ночное время.',
        plurals: [],
      },
    },
  },
  {
    name: 'cnt_region',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько регионов России увидели вашу карту Т‑Банка за год.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} России увидели вашу карту Т‑Банка за год.`,
        plurals: ['регион', 'региона', 'регионов'],
      },
    },
  },
  {
    name: MB_SEC_FIELD_NAME,
    parameterName: 'param1',
    content: {
      main: {
        title: `$param1 ${MEASURE_TEMPLATE_VALUE}`,
        text: 'Столько времени вы провели в приложении Т‑Банка за год.',
        plurals: ['минута', 'минуты', 'минут'],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} — время, которое вы провели в приложении Т‑Банка за год.`,
        plurals: ['минута', 'минуты', 'минут'],
      },
    },
  },
  {
    name: 'amt_2025_tran_dt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'В этот день вы совершили покупку с интересной суммой.',
        plurals: [],
      },
      description: {
        text: 'Вы совершили ее в %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'amt_2025_tran_amt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Однажды у вас была трата с такой интересной суммой.',
        plurals: [],
      },
      description: {
        text: `Она составила %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'jun_oleg_msg_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько сообщений вы отправили нашему Джуниор‑ассистенту.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы отправили Джуниор-ассистенту.`,
        plurals: ['сообщение', 'сообщения', 'сообщений'],
      },
    },
  },
  {
    name: 'best_combo_nm',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ваш личный бейдж в 2024 году.',
        plurals: [],
      },
      description: {
        text: 'И решили выдать вам личный титул %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'best_combo_cat',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Мы нашли у вас интересные комбо‑траты в 2024 году.',
        plurals: [],
      },
      description: {
        text: 'Вы получили его за интересные комбо‑траты в категориях %yellowColor%$param1%yellowColor% в течение 1 недели.',
        plurals: [],
      },
    },
  },
  {
    name: 'sum_sav_perc_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы заработали на вкладах и накопительных счетах.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы заработали на вкладах и накопительных счетах.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'sav_goals_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Стольких финансовых целей вы достигли по вкладам и накопительным счетам.',
        plurals: [],
      },
      description: {
        text: `А еще вы достигли %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['финансовую цель', 'финансовые цели', 'финансовых целей'],
      },
    },
  },
  {
    name: 'invest_profit_amt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Вот такой сладкий доход принесли ваши инвестиции за 2024 год.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} — вот такой сладкий доход принесли ваши инвестиции за год.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'invest_top_up_amt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'На такую сумму вы пополнили счета в инвестициях в 2024 году.',
        plurals: [],
      },
      description: {
        text: `Вы пополнили счета на %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'invest_turnover_amt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Таким был ваш торговый оборот в инвестициях в 2024 году.',
        plurals: [],
      },
      description: {
        text: `Ваш торговый оборот достиг %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'loyalty_pro_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Такую выгоду вы получили в 2024 году благодаря подписке Pro.',
        plurals: [],
      },
      description: {
        text: `Ваша выгода от подписки Pro в 2024 году составила %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'se_days_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько дней вы находились в статусе cамозанятого в Т‑Банке в 2024 году.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы находились в статусе cамозанятого в Т‑Банке в 2024 году.`,
        plurals: ['день', 'дня', 'дней'],
      },
    },
  },
  {
    name: 'loyalty_travel_sum_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько кэшбэка вы получили за покупки через наш сервис «Путешествия» в Городе в 2024 году.',
        plurals: [],
      },
      description: {
        text: `Вы получили %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} кэшбэка  за покупки через наш сервис «Путешествия» в Городе в 2024 году.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'sp_projects_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'В стольких интересных спецпроектах Т‑Банка вы поучаствовали в этом году.',
        plurals: [],
      },
      description: {
        text: `В этому году вы поучаствовали в %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} Т‑Банка.`,
        plurals: ['интересном спецпроекте', 'интересных спецпроектах', 'интересных спецпроектах'],
      },
    },
  },
  {
    name: 'cnt_days_spend_1000',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько дней в году ваши траты превышали 1 000 ₽.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} в году ваши траты превышали 1 000 ₽.`,
        plurals: ['день', 'дня', 'дней'],
      },
    },
  },
  {
    name: 'cnt_days_balance_1000',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ровно столько дней вы держали на счетах более 1 000 ₽.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы держали на счетах более 1 000 ₽.`,
        plurals: ['день', 'дня', 'дней'],
      },
    },
  },
  {
    name: 'cnt_party_eq_spend',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько клиентов Т‑Банка потратили в этом году ровно столько же, сколько и вы.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} Т‑Банка потратили в этом году ровно столько же, сколько и вы.`,
        plurals: ['клиент', 'клиента', 'клиентов'],
      },
    },
  },
  {
    name: 'nights_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько ночей в отеле вы оплатили через наш сервис «Путешествия» в Городе в 2024 году.',
        plurals: [],
      },
      description: {
        text: `А еще вы оплатили %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} в отеле.`,
        plurals: ['ночь', 'ночи', 'ночей'],
      },
    },
  },
  {
    name: 'loyalty_pemium_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Такую выгоду вы получили в 2024 году благодаря сервису Premium.',
        plurals: [],
      },
      description: {
        text: `Ваша выгода от сервиса Premium в 2024 году составила %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'jun_sav_top_up_amt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы отложили в копилку за этот год.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} ваша общая сумма пополнений в копилке за год.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'se_receipt_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Столько чеков вы сформировали как самозанятый в Т‑Банке в 2024 году.',
        plurals: [],
      },
      description: {
        text: `Вы сформировали %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['чек', 'чека', 'чеков'],
      },
    },
  },
  {
    name: 'top_ticker',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ваш самый вкусный актив в 2024 году.',
        plurals: [],
      },
      description: {
        text: 'Самый вкусный актив — %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'loyalty_accrual_amt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько кэшбэка вы получили с продуктами Т‑Банка.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} - столько принесли вам продукты Т‑Банка — помогли сэкономить.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'bk_spend_amt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько вы потратили с бизнес-карты в 2024 году.',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} вы потратили с бизнес-карты в 2024 году.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'mango_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ровно столько манго вы купили через сервис «Супермаркеты» в разделе «Город».',
        plurals: [],
      },
      description: {
        text: 'Вы купили %yellowColor%$param1%yellowColor% манго через сервис «Супермаркеты» в разделе «Город».',
        plurals: [],
      },
    },
  },
  {
    name: 'tfood_fav_item',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Это ваш любимый продукт из тех, что вы покупали через сервис Супермаркеты в разделе «Город».',
        plurals: [],
      },
      description: {
        text: 'Чаще всего в ваших чеках был этот продукт — %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'tfood_fav_item_cnt',
    parameterName: 'param1',
    content: {
      main: {
        title: `$param1`,
        text: 'Столько раз вы купили ваш любимый продукт через сервис «Супермаркеты» в разделе «Город».',
        plurals: [],
      },
      description: {
        text: `Его вы купили %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['раз', 'раза', 'раз'],
      },
    },
  },
  {
    name: 'retrograde_perc',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1%',
        text: 'Настолько отличаются ваши траты при ретроградном Меркурии, если сравнивать с другими днями.',
        plurals: [],
      },
      description: {
        text: 'Ваши траты при ретроградном Меркурии отличаются на %yellowColor%$param1%%yellowColor%, если сравнивать с другими днями.',
        plurals: [],
      },
    },
  },
  {
    name: 'top_top_up_amt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'На такую сумму было ваше самое большое пополнение карты одним платежом.',
        plurals: [],
      },
      description: {
        text: `Ваше самое большое пополнение карты одним платежом было на %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'top_top_up_dt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Именно в этот день было сделано ваше самое большое пополнение карты одним платежом.',
        plurals: [],
      },
      description: {
        text: 'Вы сделали его %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
];
